import { computed, type ComputedRef } from 'vue'

import type { InsightActionScope, RunScope } from '../flows/insightActionFlow.types'

import { useAccount, useWorkspace } from '@/features/account'

export interface UseInsightActionScope {
  accountId: ComputedRef<number | null>
  workspaceId: ComputedRef<number | null>
  forInsight: (insightId: number | null | undefined) => InsightActionScope | null
  forRun: () => RunScope | null
}

function numericId(value: number | string | undefined): number | null {
  if (value === undefined) return null
  const id = Number(value)
  return Number.isFinite(id) ? id : null
}

export function useInsightActionScope(): UseInsightActionScope {
  const account = useAccount()
  const workspace = useWorkspace()

  const accountId = computed(() => numericId(account.accountId.value))
  const workspaceId = computed(() => numericId(workspace.workspaceId.value))

  function forRun(): RunScope | null {
    if (accountId.value === null || workspaceId.value === null) return null
    return { accountId: accountId.value, workspaceId: workspaceId.value }
  }

  return {
    accountId,
    workspaceId,
    forInsight: (insightId) => {
      const base = forRun()
      const id = numericId(insightId ?? undefined)
      if (!base || id === null) return null
      return { ...base, insightId: id }
    },
    forRun,
  }
}
